<template>
  <div>
    <!-- <h3>Check your business eligibility in 60 seconds</h3> -->
    <label class="label eligibility_label">Check your eligibility in 60 seconds</label>
    <Input
      @enter="next"
      :inputField="inputs.requestedAmount"
      inputName="How much funding do you need?"
      inputType="currency"
      :range="[500, 1000000]"
      :icons="{ left: 'fa-dollar-sign' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.monthly_sales"
      inputName="What is your Average Monthly Sales?"
      inputType="currency"
      :icons="{ left: 'fa-dollar-sign' }"
    />
    <div class="estimated_yearly_sales_container">
      <label class="label estimate_yearly_sales">Estimated Yearly Sales: {{ yearly_sales }}</label>
      <!-- <div class="estimated_result">{{ yearly_sales }}</div> -->
    </div>
    <div id="name_container">
      <Input
        @enter="next"
        :inputField="inputs.fn"
        inputName="First Name"
        inputType="name"
        autocomplete="given-name"
      />
      <Input
        @enter="next"
        :inputField="inputs.ln"
        inputName="Last Name"
        inputType="name"
        autocomplete="family-name"
      />
    </div>
    <Input
      @enter="next"
      :inputField="inputs.email"
      inputName="Business Email Address"
      inputType="email"
      :icons="{ right: 'fa-envelope' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.phone"
      inputName="Cell Phone"
      inputType="phone"
      :icons="{ right: 'fa-mobile-alt' }"
    />
    <div id="checkbox_sms">
      <Checkbox
        :inputField="inputs.smsOptIn"
        inputName="SMS Optin"
        inputType=""
      >
        By checking this box, you agree to receive <b>application status and funding decision notifications</b> along with recurring automated 
        promotional and personalized marketing text messages(e.g. AI content) from Cardiff and partners at the number you provide.
        Consent is not a condition of any purchase. 
        Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. 
        View <a href="https://attnl.tv/t/3Rk" target="_blank">Terms</a> & <a href="https://attnl.tv/p/3Rk" target="_blank">Privacy</a>.
      </Checkbox>
    </div>
    <div class="buttons is-right" @click="handleBlur" style="margin-bottom: 0;">
      <a class="button is-link padded-button next-button continue-button" @click="next">
        Continue
      </a>
    </div>
    <label class="label" id="agree_label">
      By clicking Continue you agree to the <a href="/application-agreement/" target="_blank">
        Cardiff Application Agreement
      </a>
      and
      <a href="/e-sign-consent/" target="_blank">
        E-Sign Consent Agreement 
      </a>.
    </label>
  </div>
</template>

<script>
import Vue from "vue";
import Input from "@/components/shared/Input";
import Checkbox from "@/components/shared/Checkbox";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "GetStarted",
  components: {
    Input,
    Checkbox,
  },
  mixins: [ApplyPage],
  props: {
    amt: String,
    lang: String,
  },
  created: function () {
    this.language = "en";
    if (this.$route.params.language) {
      this.language = this.$route.params.language;
    }
  },
  data() {
    return {
      obj: "business",
      inputs: {
        requestedAmount: Input.model(this.amt),
        monthly_sales: Input.model(),
        fn: Input.model(),
        ln: Input.model(),
        email: Input.model(),
        phone: Input.model(),
        smsConsent: Input.model(),
        utm_device_type: this.getDeviceType(),
        utm_browser: this.getBrowserName(),
        utm_OS: this.getOperatingSystem(),
        
        gclid: this.getGCLID(),
        fbclid: this.getFBCLID(),
        fbp: this.getFBP(),
        ttclid: this.getTTCLID(),
        
        smsOptIn: Input.model(),
      },
      show_address_fields: true,
      selected_address: false,
      full_address: "Please type and select your business address",
      yearly_sales: "$ 0",
      marks_requested: []
    };
  },
  methods: {
    handleBlur: function () {
      console.log("focus out");
    },
    getOperatingSystem: function () {
      let userAgent = navigator.userAgent || window.navigator.userAgent;
      let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
      let iosPlatforms = ["iPhone", "iPad", "iPod"];

      let os = null;

      macosPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });

      iosPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });

      windowsPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });
      if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(userAgent)) {
        os = "Linux";
      } else if (!os) {
        os = "Other";
      }
      return os;
    },
    getDeviceType: () => {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    },
    getBrowserName: function () {
      let userAgent = navigator.userAgent;
      let browserName;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "Chrome";
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "Firefox";
      } else if (userAgent.match(/safari/i)) {
        browserName = "Safari";
      } else if (userAgent.match(/opr\//i)) {
        browserName = "Opera";
      } else if (userAgent.match(/edg/i)) {
        browserName = "Edge";
      } else {
        browserName = "Unknown browser";
      }

      return browserName;
    },
    getGCLID() {
      // console.log(getWithExpiry("gclid"));
      let gclid = getWithExpiry("gclid");
      if (!gclid) return "";
      return gclid;
    },
    getFBCLID() {
      console.log(getWithExpiry("fbclid"));
      let fbclid = getWithExpiry("fbclid");
      if (!fbclid) return "";
      return fbclid;
    },
    getTTCLID() {
      console.log(getWithExpiry("ttclid"));
      let ttclid = getWithExpiry("ttclid");
      if (!ttclid) return "";
      return ttclid;
    },
    getFBP() {
      console.log(getWithExpiry("_fbp"));
      let _fbp = getWithExpiry("_fbp");
      if (!_fbp) return "";
      return _fbp;
    },
  },
  mounted: function () {
    this.show_address_fields = false;
    //@todo pass this validation inside the component
    let self = this;
    $("#map").focusout(function () {
      // console.log("selected address", self.selected_address);
      if (self.selected_address === false) {
        self.show_address_fields = true;
      }
    });
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {
        // console.log("new value: ");
        // console.log(newValue.refer.value);
        let monthly_sales = Number(
          newValue.monthly_sales.value.replace(/[^0-9\.-]+/g, "")
        );
        if (monthly_sales !== "") {
          let year_sales = monthly_sales * 12;
          let yearly_sales_string = year_sales
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.yearly_sales = "$ " + yearly_sales_string;
        }
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eligibility_label{
  margin-bottom: 22px;
  font-weight: bold;
  color: #000;
  font-family: Roboto;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.2px;
}
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
.address_selected {
  color: green;
}
</style>
<style scoped>
#agree_label{
  margin-left: 8px;
  margin-left: 8px;
  font-size: 12px;
  text-align: center;
  margin-bottom: 15px;
  margin-top: 5px;
}
.estimate_yearly_sales {
  color: #A5A5A5;
  display: inline-block;
  text-align: right;
}
.yearly_sales_amount {
  color: green;
  display: inline-block;
}
.estimated_yearly_sales_container{
  margin-bottom: 0.75rem;
  width: 100%;
  display: inline;
}
.estimate_yearly_sales{
  width: 100%;
}
.estimated_result{
  width: 29%;
  text-align: right;
  color: gray;
}
#name_container{
  display: inline-flex;
  width: 100%;
}
#name_container div{
  width: 50%;
  margin-right: 10px;
}
</style>
<style>
#checkbox_sms .choice p{
  font-size: 8px!important;
  text-align: justify;
  /* text-justify: inter-word; */
  line-height: 15px;
  font-family: 'Roboto';
  color: #A5A5A5;
}
#checkbox_sms .choice{
  padding-left: 5px;
  padding-right: 5px;
  
}
/* #checkbox_sms .fa-check-circle:before,#checkbox_sms .fa-circle:before{
  font-size: 1.5em;
} */
</style>